<div class="col-lg-12 col-md-12 col-sm-12 card" [ngClass]="{'dark-mode': darkMode}">
  <div class="card-header border-header">
    <div class="row d-flex justify-content-between align-items-center p-2">
      <h3 class="" translate>user.frames</h3>
      <!-- search -->
      <div *ngIf="role === 'root'" class="d-flex search-container">
        <div class="search-text d-flex">
          <input type="text" class="search" (input)="applyFilterAddedFrames()" [(ngModel)]="searchParamAll"
            placeholder="Search Frames...">
          <div class="d-flex flex-row align-items-center">
            <span class="exit" (click)="clearSearch()"></span>
            <span class="line"></span>
          </div>
        </div>
        <span class="search-icon"><i class="fa fa-search"></i></span>
      </div>
      <!-- ./search -->
      <div *ngIf="currentUser.role.name === 'root'">
        <button type="button" class="custom-button add-button mr-2"
          (click)="showDialogAddFrame(addFrameModal)">Create
          Frame <i class="fa fa-plus" style="margin-left: 7px;"></i></button>
        <button class="custom-button add-button" style="border: 1px solid var(--clr-red);" [routerLink]="['frame-configurator']" [queryParams]="urlParams">Frame
          Configurator</button>
      </div>
    </div>

  </div>
  <div *ngIf="role !== 'root'" class="form-group">
    <!-- search -->
    <div #searchContainer [ngClass]="{'active' : showMyContainer}" class="div select-bg search-container"
      style="display: block;">
      <input type="text" readonly class="search" style="height: 44px; display: block; width: 100%; padding-left: 12px;"
        (click)="openDropdown()" name="selectedFrame" [(ngModel)]="selectedFrame">

      <div class="prikaz" *ngIf="showMyContainer">
        <div class="backdrop" (click)="openDropdown()"></div>
        <div style="z-index: 100; overflow-y: auto;">
          <div class="divider"></div>
          <input type="text" class="search-marke" (input)="applyFilter()" [attr.placeholder]="'user.search' | translate"
            name="searchParam" name="searchParam" [(ngModel)]="searchParam">
          <ul style="margin-bottom: 12px;">
            <li *ngFor="let frame of framesSearch" (click)="addFrame(frame.id)">
              {{ frame.name }}
              <ng-container>
                <div class="position-relative">
                  <div class="bg-all-files" style="cursor: pointer;" (click)="openFrameModal(frameModal, frame)"
                    [style.background-image]="(frame.preview != null) ? 'url(' + frame.preview + ')' : 'url(assets/img/no-image.png)'">
                  </div>
                </div>
              </ng-container>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>

  <hr>
  <div class="card-body">
    <div class="row">
      <div *ngIf="framesSearchAll && !framesSearchAll.length" style="min-height: 60px;">
        <p class="no-data-message" translate>user.noFrames</p>
      </div>
      <div class="col-md-3 col-sm-6"
        *ngFor="let frame of framesSearchAll | slice: (page-1) * perPage : (page-1) * perPage + perPage; let index = index">
        <div class="root-application-bg-container ">
          <div class="root-application-image-delete" style="cursor: pointer;"
            (click)="openFrameModal(dialogDelete, frame)"></div>
          <div *ngIf="currentUser.role.name === 'root'" class="root-application-image-delete settings-icon" style="cursor: pointer; left: 0;"
            (click)="editFrame(addFrameModal, frame)"></div>
          <div class="root-application-bg" style="cursor: pointer;" (click)="openFrameModal(frameModal, frame)"
            [style.background-image]="(frame.preview != null) ? 'url(' + frame.preview + ')' : 'url(assets/img/no-image.png)'">
          </div>
          <div class="root-application-filename widget-user-username"> {{frame.name}}</div>
        </div>
      </div>
    </div>
    <ngb-pagination *ngIf="framesSearchAll && framesSearchAll.length > 16" [collectionSize]="framesSearchAll.length"
      [(pageSize)]="perPage" [(page)]="page" [maxSize]="5" [rotate]="true"
      (pageChange)="jumpToPage($event)"></ngb-pagination>
  </div>
</div>


<!-- add frame -->
<ng-template #addFrameModal>
  <div class="backdrop-content">
    <form #frameForm="ngForm" novalidate>
      <div class="form-group">
        <label translate>global.name</label>
        <input type="text" #name="ngModel" [ngModel]="frame.name" required class="form-control"
          placeholder="Frame name..." [class.is-invalid]="name.invalid && name.touched" name="name">
        <small class="text-danger" [class.d-none]="name.valid || name.untouched">Name is required</small>
      </div>
      <div class="form-group">
        <label>Configuration</label>
        <textarea #conf="ngModel" [ngModel]="frame.configuration | json" (input)="convertToJSON()" name="conf"
          id="json-textArea" cols="30" rows="10"></textarea>
      </div>
      <button class="btn btn-primary" *ngIf="frame.name == ''" [disabled]="frameForm.form.invalid" type="submit"
        (click)="createFrame(frameForm)">Submit</button>
      <button class="btn btn-primary" *ngIf="frame.name != ''" [disabled]="frameForm.form.invalid" type="submit"
        (click)="onEdit(frameForm)" translate>global.edit</button>
    </form>
  </div>
</ng-template>

<!-- Modal delete frame-->
<ng-template #dialogDelete let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="modal-title" style="font-size: 16px">Are you sure you want to delete <span
        style="font-weight: bold;">{{framesToChanged.name}}</span> ?</h3>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <button type="button" class="btn btn-outline-dark btn-yes" (click)="deleteFrame(framesToChanged)"
      translate>global.yes</button>
    <button type="button" class="btn btn-outline-dark btn-no" (click)="c('No click')" translate>global.no</button>
  </div>
</ng-template>

<!-- Modal Add Frame File -->
<ng-template #dialogAddFrameFile let-c="close" let-d="dismiss">
  <div>
    <div class="uploading" *ngIf="uploading">
      <strong>Uploading, please wait...</strong>
    </div>
    <div class="modal-header">
      <h4 class="modal-title">Add Frame File</h4>
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form #frameFilesForm="ngForm" (ngSubmit)="sendFrameFile(frameFilesForm)" class="form-vehicle">
        <div class="row">
          <div class="input-group mb-3 col-lg-12 col-md-12 col-sm-12">
            <input type="file" name="image" ngModel (change)="getFrameFile($event)" placeholder="Choose Image" />
          </div>
          <div class="input-group mb-3 col-lg-12 col-md-12 col-sm-12">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon3">Key</span>
            </div>
            <input type="text" class="form-control" id="key" name="key" ngModel>
          </div>
          <div class="input-group mb-3 col-lg-12 col-md-12 col-sm-12">
            <button type="submit" class="form-control btn btn-block btn-success">Add</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<!-- Modal Delete Frame File -->
<ng-template #frameModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{framesToChanged.name}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row" style="display: flex !important;">
      <div *ngFor="let file of framesToChanged.frameFiles" class="position-relative" style="padding: 0 5px;">
        <div class="bg-files bg-hover" style="margin:auto;"
          [style.background-image]="'url(' + file.fileInfo.path + ')'">
        </div>
        <div *ngIf="currentUser.role.name === 'root'" class="delete-preset root-application-image-delete" (click)="deleteFrameFile(file)"></div>
        <div style="text-align: center;"> Key: {{file.key}}</div>
      </div>
    </div>
    <div *ngIf="currentUser.role.name === 'root'" class="btn-success col-md-4" (click)="openAddFrameFile(dialogAddFrameFile)">Add File</div>
  </div>
</ng-template>